/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Section} from '../models/Section';
import type {SectionRequest} from '../models/SectionRequest';

export interface CreateSection$Request {
    sectionRequest: SectionRequest;
}

export interface CreateSection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createSectionRequest = createAction<PayloadData<void, CreateSection$Request>>('CONFERENCE_SECTIONS__CREATE_SECTION__REQUEST');
export const createSectionSuccess = createAction<PayloadData<number, CreateSection$Request>>('CONFERENCE_SECTIONS__CREATE_SECTION__SUCCESS');
export const createSectionFailure = createAction<PayloadData<Error, CreateSection$Request, true>>('CONFERENCE_SECTIONS__CREATE_SECTION__FAILURE');

export const createSectionActions = [
    createSectionRequest,
    createSectionSuccess,
    createSectionFailure
] as const;

/**
 * @param {SectionRequest} meta.sectionRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createSection = (meta: CreateSection$Request, config?: CreateSection$Config) => {
    return {
        CALL_API: {
            types: createSectionActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/conferences/sections`,
            TRANSPORT_REQUEST_BODY: meta.sectionRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteSection$Request {
    sectionId: number;
}

export interface DeleteSection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteSectionRequest = createAction<PayloadData<void, DeleteSection$Request>>('CONFERENCE_SECTIONS__DELETE_SECTION__REQUEST');
export const deleteSectionSuccess = createAction<PayloadData<void, DeleteSection$Request>>('CONFERENCE_SECTIONS__DELETE_SECTION__SUCCESS');
export const deleteSectionFailure = createAction<PayloadData<Error, DeleteSection$Request, true>>('CONFERENCE_SECTIONS__DELETE_SECTION__FAILURE');

export const deleteSectionActions = [
    deleteSectionRequest,
    deleteSectionSuccess,
    deleteSectionFailure
] as const;

/**
 * @param {number} meta.sectionId The section id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteSection = (meta: DeleteSection$Request, config?: DeleteSection$Config) => {
    return {
        CALL_API: {
            types: deleteSectionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/conferences/sections/${meta.sectionId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSection$Request {
    sectionId: number;
}

export interface GetSection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSectionRequest = createAction<PayloadData<void, GetSection$Request>>('CONFERENCE_SECTIONS__GET_SECTION__REQUEST');
export const getSectionSuccess = createAction<PayloadData<Section, GetSection$Request>>('CONFERENCE_SECTIONS__GET_SECTION__SUCCESS');
export const getSectionFailure = createAction<PayloadData<Error, GetSection$Request, true>>('CONFERENCE_SECTIONS__GET_SECTION__FAILURE');

export const getSectionActions = [
    getSectionRequest,
    getSectionSuccess,
    getSectionFailure
] as const;

/**
 * @param {number} meta.sectionId The section id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSection = (meta: GetSection$Request, config?: GetSection$Config) => {
    return {
        CALL_API: {
            types: getSectionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/sections/${meta.sectionId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSections$Request {
    conferenceId: number;
}

export interface GetSections$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSectionsRequest = createAction<PayloadData<void, GetSections$Request>>('CONFERENCE_SECTIONS__GET_SECTIONS__REQUEST');
export const getSectionsSuccess = createAction<PayloadData<Array<Section>, GetSections$Request>>('CONFERENCE_SECTIONS__GET_SECTIONS__SUCCESS');
export const getSectionsFailure = createAction<PayloadData<Error, GetSections$Request, true>>('CONFERENCE_SECTIONS__GET_SECTIONS__FAILURE');

export const getSectionsActions = [
    getSectionsRequest,
    getSectionsSuccess,
    getSectionsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSections = (meta: GetSections$Request, config?: GetSections$Config) => {
    return {
        CALL_API: {
            types: getSectionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/sections`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateOrder$Request {
    requestBody: { [key: string]: number; };
}

export interface UpdateOrder$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateOrderRequest = createAction<PayloadData<void, UpdateOrder$Request>>('CONFERENCE_SECTIONS__UPDATE_ORDER__REQUEST');
export const updateOrderSuccess = createAction<PayloadData<void, UpdateOrder$Request>>('CONFERENCE_SECTIONS__UPDATE_ORDER__SUCCESS');
export const updateOrderFailure = createAction<PayloadData<Error, UpdateOrder$Request, true>>('CONFERENCE_SECTIONS__UPDATE_ORDER__FAILURE');

export const updateOrderActions = [
    updateOrderRequest,
    updateOrderSuccess,
    updateOrderFailure
] as const;

/**
 * @param {{ [key: string]: number; }} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateOrder = (meta: UpdateOrder$Request, config?: UpdateOrder$Config) => {
    return {
        CALL_API: {
            types: updateOrderActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/conferences/sections/order`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateSection$Request {
    sectionId: number;
    sectionRequest: SectionRequest;
}

export interface UpdateSection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateSectionRequest = createAction<PayloadData<void, UpdateSection$Request>>('CONFERENCE_SECTIONS__UPDATE_SECTION__REQUEST');
export const updateSectionSuccess = createAction<PayloadData<void, UpdateSection$Request>>('CONFERENCE_SECTIONS__UPDATE_SECTION__SUCCESS');
export const updateSectionFailure = createAction<PayloadData<Error, UpdateSection$Request, true>>('CONFERENCE_SECTIONS__UPDATE_SECTION__FAILURE');

export const updateSectionActions = [
    updateSectionRequest,
    updateSectionSuccess,
    updateSectionFailure
] as const;

/**
 * @param {number} meta.sectionId The section id
 * @param {SectionRequest} meta.sectionRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateSection = (meta: UpdateSection$Request, config?: UpdateSection$Config) => {
    return {
        CALL_API: {
            types: updateSectionActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/conferences/sections/${meta.sectionId}`,
            TRANSPORT_REQUEST_BODY: meta.sectionRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

